/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminDocumentControllerCreateDocument } from '../fn/document/admin-document-controller-create-document';
import { AdminDocumentControllerCreateDocument$Params } from '../fn/document/admin-document-controller-create-document';
import { adminDocumentControllerDeleteDocument } from '../fn/document/admin-document-controller-delete-document';
import { AdminDocumentControllerDeleteDocument$Params } from '../fn/document/admin-document-controller-delete-document';
import { adminDocumentControllerGetDocumentById } from '../fn/document/admin-document-controller-get-document-by-id';
import { AdminDocumentControllerGetDocumentById$Params } from '../fn/document/admin-document-controller-get-document-by-id';
import { adminDocumentControllerSearchOffset } from '../fn/document/admin-document-controller-search-offset';
import { AdminDocumentControllerSearchOffset$Params } from '../fn/document/admin-document-controller-search-offset';
import { adminDocumentControllerUpdateDocument } from '../fn/document/admin-document-controller-update-document';
import { AdminDocumentControllerUpdateDocument$Params } from '../fn/document/admin-document-controller-update-document';
import { CursorSearchDocumentResponseDto } from '../models/cursor-search-document-response-dto';
import { documentControllerCancelShareDocument } from '../fn/document/document-controller-cancel-share-document';
import { DocumentControllerCancelShareDocument$Params } from '../fn/document/document-controller-cancel-share-document';
import { documentControllerCreateDocument } from '../fn/document/document-controller-create-document';
import { DocumentControllerCreateDocument$Params } from '../fn/document/document-controller-create-document';
import { documentControllerDeleteDocument } from '../fn/document/document-controller-delete-document';
import { DocumentControllerDeleteDocument$Params } from '../fn/document/document-controller-delete-document';
import { documentControllerDeleteManyDocument } from '../fn/document/document-controller-delete-many-document';
import { DocumentControllerDeleteManyDocument$Params } from '../fn/document/document-controller-delete-many-document';
import { documentControllerEmailShare } from '../fn/document/document-controller-email-share';
import { DocumentControllerEmailShare$Params } from '../fn/document/document-controller-email-share';
import { documentControllerFindById } from '../fn/document/document-controller-find-by-id';
import { DocumentControllerFindById$Params } from '../fn/document/document-controller-find-by-id';
import { documentControllerSearchCursor } from '../fn/document/document-controller-search-cursor';
import { DocumentControllerSearchCursor$Params } from '../fn/document/document-controller-search-cursor';
import { documentControllerShareDocument } from '../fn/document/document-controller-share-document';
import { DocumentControllerShareDocument$Params } from '../fn/document/document-controller-share-document';
import { documentControllerUpdateDocument } from '../fn/document/document-controller-update-document';
import { DocumentControllerUpdateDocument$Params } from '../fn/document/document-controller-update-document';
import { DocumentDto } from '../models/document-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class DocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentControllerSearchCursor()` */
  static readonly DocumentControllerSearchCursorPath = '/api/treatment-document/cursor';

  /**
   * 페이지 기반 치료 문서 검색
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentControllerSearchCursor$Response(params: DocumentControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorSearchDocumentResponseDto>> {
    return documentControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 페이지 기반 치료 문서 검색
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentControllerSearchCursor(params: DocumentControllerSearchCursor$Params, context?: HttpContext): Observable<CursorSearchDocumentResponseDto> {
    return this.documentControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorSearchDocumentResponseDto>): CursorSearchDocumentResponseDto => r.body)
    );
  }

  /** Path part for operation `documentControllerFindById()` */
  static readonly DocumentControllerFindByIdPath = '/api/treatment-document/{id}';

  /**
   * 치료 문서 상세 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentControllerFindById$Response(params: DocumentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return documentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 상세 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentControllerFindById(params: DocumentControllerFindById$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.documentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

  /** Path part for operation `documentControllerDeleteDocument()` */
  static readonly DocumentControllerDeleteDocumentPath = '/api/treatment-document/{id}';

  /**
   * 치료 문서 삭제
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentControllerDeleteDocument$Response(params: DocumentControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return documentControllerDeleteDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 삭제
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentControllerDeleteDocument(params: DocumentControllerDeleteDocument$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.documentControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

  /** Path part for operation `documentControllerUpdateDocument()` */
  static readonly DocumentControllerUpdateDocumentPath = '/api/treatment-document/{id}';

  /**
   * 치료 문서 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerUpdateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerUpdateDocument$Response(params: DocumentControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return documentControllerUpdateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerUpdateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerUpdateDocument(params: DocumentControllerUpdateDocument$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.documentControllerUpdateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

  /** Path part for operation `documentControllerCreateDocument()` */
  static readonly DocumentControllerCreateDocumentPath = '/api/treatment-document';

  /**
   * 새 치료 문서 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerCreateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerCreateDocument$Response(params: DocumentControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return documentControllerCreateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 치료 문서 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerCreateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerCreateDocument(params: DocumentControllerCreateDocument$Params, context?: HttpContext): Observable<boolean> {
    return this.documentControllerCreateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `documentControllerDeleteManyDocument()` */
  static readonly DocumentControllerDeleteManyDocumentPath = '/api/treatment-document';

  /**
   * 치료 문서 삭제
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerDeleteManyDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentControllerDeleteManyDocument$Response(params: DocumentControllerDeleteManyDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return documentControllerDeleteManyDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 삭제
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerDeleteManyDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentControllerDeleteManyDocument(params: DocumentControllerDeleteManyDocument$Params, context?: HttpContext): Observable<boolean> {
    return this.documentControllerDeleteManyDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `documentControllerEmailShare()` */
  static readonly DocumentControllerEmailSharePath = '/api/treatment-document/email-share';

  /**
   * 문서 이메일 공유
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerEmailShare()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerEmailShare$Response(params: DocumentControllerEmailShare$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return documentControllerEmailShare(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 이메일 공유
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerEmailShare$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerEmailShare(params: DocumentControllerEmailShare$Params, context?: HttpContext): Observable<boolean> {
    return this.documentControllerEmailShare$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `documentControllerShareDocument()` */
  static readonly DocumentControllerShareDocumentPath = '/api/treatment-document/share';

  /**
   * 치료 문서 공유
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerShareDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerShareDocument$Response(params: DocumentControllerShareDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return documentControllerShareDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 공유
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerShareDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerShareDocument(params: DocumentControllerShareDocument$Params, context?: HttpContext): Observable<boolean> {
    return this.documentControllerShareDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `documentControllerCancelShareDocument()` */
  static readonly DocumentControllerCancelShareDocumentPath = '/api/treatment-document/cancel-share';

  /**
   * 치료 문서 공유 취소
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentControllerCancelShareDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerCancelShareDocument$Response(params: DocumentControllerCancelShareDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return documentControllerCancelShareDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 공유 취소
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentControllerCancelShareDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentControllerCancelShareDocument(params: DocumentControllerCancelShareDocument$Params, context?: HttpContext): Observable<boolean> {
    return this.documentControllerCancelShareDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerSearchOffset()` */
  static readonly AdminDocumentControllerSearchOffsetPath = '/api/document-admin';

  /**
   * 치료 문서 검색
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerSearchOffset$Response(params: AdminDocumentControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return adminDocumentControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 검색
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerSearchOffset(params: AdminDocumentControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.adminDocumentControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerCreateDocument()` */
  static readonly AdminDocumentControllerCreateDocumentPath = '/api/document-admin';

  /**
   * 새 치료 문서 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerCreateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentControllerCreateDocument$Response(params: AdminDocumentControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return adminDocumentControllerCreateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 치료 문서 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerCreateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentControllerCreateDocument(params: AdminDocumentControllerCreateDocument$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.adminDocumentControllerCreateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerGetDocumentById()` */
  static readonly AdminDocumentControllerGetDocumentByIdPath = '/api/document-admin/{id}';

  /**
   * 치료 문서 상세 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerGetDocumentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerGetDocumentById$Response(params: AdminDocumentControllerGetDocumentById$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return adminDocumentControllerGetDocumentById(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 상세 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerGetDocumentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerGetDocumentById(params: AdminDocumentControllerGetDocumentById$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.adminDocumentControllerGetDocumentById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerDeleteDocument()` */
  static readonly AdminDocumentControllerDeleteDocumentPath = '/api/document-admin/{id}';

  /**
   * 치료 문서 삭제
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerDeleteDocument$Response(params: AdminDocumentControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return adminDocumentControllerDeleteDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 삭제
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentControllerDeleteDocument(params: AdminDocumentControllerDeleteDocument$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.adminDocumentControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentControllerUpdateDocument()` */
  static readonly AdminDocumentControllerUpdateDocumentPath = '/api/document-admin/{id}';

  /**
   * 치료 문서 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentControllerUpdateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentControllerUpdateDocument$Response(params: AdminDocumentControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return adminDocumentControllerUpdateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentControllerUpdateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentControllerUpdateDocument(params: AdminDocumentControllerUpdateDocument$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.adminDocumentControllerUpdateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

}
